import React, { lazy, Suspense } from 'react';
import { Button } from 'rizzui';
import cn from '@core/utils/class-names';
import { PiArrowLineDownBold } from 'react-icons/pi';
import { useModal } from '../shared/modal-views/use-modal';

// Lazy-load FileUpload component
const FileUpload = lazy(() => import('../shared/file-upload'));

type ImportButtonProps = {
  title?: string;
  modalBtnLabel?: string;
  className?: string;
  buttonLabel?: string;
};

export default function ImportButton({
  title,
  modalBtnLabel = 'Import File',
  className,
  buttonLabel = 'Import',
}: ImportButtonProps) {
  const { openModal } = useModal();

  return (
    <Button
      onClick={() =>
        openModal({
          view: (
            <Suspense fallback={null}>
              <FileUpload
                label={title}
                accept="csv"
                multiple={false}
                btnLabel={modalBtnLabel}
              />
            </Suspense>
          ),
          customSize: '480px',
        })
      }
      className={cn('w-full @lg:w-auto', className)}
    >
      <PiArrowLineDownBold className="me-1.5 h-[17px] w-[17px]" />
      {buttonLabel}
    </Button>
  );
}